import React from 'react';
import {Box} from '@mui/material';
import {t} from '../../themes/statamicTokens';

const MonoChip = ({children, sx}) => (
    <Box
        component="span"
        sx={{
            display: 'inline-block',
            px: 0.75,
            py: 0.25,
            borderRadius: `${t.radius.sm}px`,
            backgroundColor: t.color.chip.monoBg,
            color: t.color.chip.monoText,
            fontFamily: t.font.mono,
            fontSize: `${t.type.mono.size}px`,
            fontWeight: t.type.mono.weight,
            lineHeight: t.type.mono.lineHeight,
            border: `1px solid ${t.color.border.hairline}`,
            ...sx,
        }}
    >
        {children}
    </Box>
);

export default MonoChip;
